export enum UserRailyOfficerListRequestOrder {
  FIRST_NAME_ASC = "FIRST_NAME_ASC",
  FIRST_NAME_DESC = "FIRST_NAME_DESC",
  LAST_NAME_ASC = "LAST_NAME_ASC",
  LAST_NAME_DESC = "LAST_NAME_DESC",
  USERNAME_ASC = "USERNAME_ASC",
  USERNAME_DESC = "USERNAME_DESC",
}

export enum UserRailyOfficerListRequestStatusCriteria {
  ACTIVE = "ACTIVE",
  DELETED = "DELETED",
  ALL = "ALL",
}

export type UserRailyOfficerListRequestQueryParams = {
  firstName?: string;
  lastName?: string;
  username?: string;
  email?: string;
  statusCriteria?: UserRailyOfficerListRequestStatusCriteria;
  order?: UserRailyOfficerListRequestOrder;
  offset?: number;
  limit?: number;
  creationStart?: Date;
  creationEnd?: Date;
};

type UserRailyOfficerListRequest = {
  offset?: number;
  limit?: number;
  creationStart?: Date;
  creationEnd?: Date;
  firstName?: string;
  lastName?: string;
  username?: string;
  email?: string;
  statusCriteria?: UserRailyOfficerListRequestStatusCriteria;
  order?: UserRailyOfficerListRequestOrder;
};

export default UserRailyOfficerListRequest;
